import { Alert, Heading, VFlow } from 'bold-ui'
import React from 'react'
import { Accordion, AccordionItem } from 'react-accessible-accordion'

import { NewsInternalEstabilizacaoV41 } from './NewsInternalEstabilizacaoV_41'
import { NewsInternalEstabilizacaoV42 } from './NewsInternalEstabilizacaoV_42'
import { NewsInternalEstabilizacaoV43 } from './NewsInternalEstabilizacaoV_43'
import { NewsInternalEstabilizacaoV45 } from './NewsInternalEstabilizacaoV_45'
import { NewsInternalPanelV4_0 as NewsInternalPanelVQuatro } from './NewsInternalPanelV4_0'
import { NewsInternalPanelV4_10 as NewsInternalPanelVQuatroUm } from './NewsInternalPanelV4_10'
import { NewsInternalPanelV4_20 as NewsInternalPanelVQuatroDois } from './NewsInternalPanelV4_20'
import { NewsInternalPanelV4_30 as NewsInternalPanelVQuatroTres } from './NewsInternalPanelV4_30'
import { NewsInternalPanelV4_40 as NewsInternalPanelVQuatroQuatro } from './NewsInternalPanelV4_40'
import { NewsInternalPanelV4_50 as NewsInternalPanelVQuatroCinco } from './NewsInternalPanelV4_50'
import { NewsInternalVEstabilizacao } from './NewsInternalVEstabilizacao'
import { NewsSection } from './NewsSection'

export function News() {
  return (
    <>
      <VFlow>
        <Heading level={1}>Novidades da versão</Heading>
        <Alert type='info' inline>
          <strong>O PEC está sendo redesenhado para ficar ainda mais fácil de usar!</strong> A cada versão, diferentes
          módulos serão atualizados com a nova interface. Para receber as próximas novidades, o sistema deve ser
          atualizado com a versão mais recente disponível.
        </Alert>
        <Accordion allowZeroExpanded={true} preExpanded={['estabilizacaoV45']}>
          <AccordionItem uuid='estabilizacaoV45'>
            <NewsSection title='Versões de estabilização (4.5)'>
              <NewsInternalEstabilizacaoV45 />
            </NewsSection>
          </AccordionItem>
          <AccordionItem uuid='4.5'>
            <NewsSection title='Versão 4.5'>
              <NewsInternalPanelVQuatroCinco />
            </NewsSection>
          </AccordionItem>
          <AccordionItem uuid='4.4'>
            <NewsSection title='Versão 4.4'>
              <NewsInternalPanelVQuatroQuatro />
            </NewsSection>
          </AccordionItem>
          <AccordionItem uuid='estabilizacaoV43'>
            <NewsSection title='Versões de estabilização (4.3)'>
              <NewsInternalEstabilizacaoV43 />
            </NewsSection>
          </AccordionItem>
          <AccordionItem uuid='4.3'>
            <NewsSection title='Versão 4.3'>
              <NewsInternalPanelVQuatroTres />
            </NewsSection>
          </AccordionItem>
          <AccordionItem uuid='estabilizacaoV42'>
            <NewsSection title='Versões de estabilização (4.2)'>
              <NewsInternalEstabilizacaoV42 />
            </NewsSection>
          </AccordionItem>
          <AccordionItem uuid='4.2'>
            <NewsSection title='Versão 4.2'>
              <NewsInternalPanelVQuatroDois />
            </NewsSection>
          </AccordionItem>
          <AccordionItem uuid='estabilizacaoV41'>
            <NewsSection title='Versões de estabilização (4.1)'>
              <NewsInternalEstabilizacaoV41 />
            </NewsSection>
          </AccordionItem>
          <AccordionItem uuid='4.1'>
            <NewsSection title='Versão 4.1'>
              <NewsInternalPanelVQuatroUm />
            </NewsSection>
          </AccordionItem>
          <AccordionItem uuid='estabilizacao'>
            <NewsSection title='Versões de estabilização (4.0)'>
              <NewsInternalVEstabilizacao />
            </NewsSection>
          </AccordionItem>
          <AccordionItem uuid='4.0'>
            <NewsSection title='Versão 4.0'>
              <NewsInternalPanelVQuatro />
            </NewsSection>
          </AccordionItem>
        </Accordion>
      </VFlow>
    </>
  )
}
